// Utility function to convert Lexical JSON to HTML
export const lexicalToHtml = (lexicalJson: string): string => {
    try {
        const parsed = JSON.parse(lexicalJson);
        
        if (!parsed.root || !parsed.root.children) {
            return lexicalJson; // Return original if not valid Lexical format
        }
        
        return convertNodeToHtml(parsed.root);
    } catch (error) {
        console.error('Error parsing Lexical JSON:', error);
        return lexicalJson; // Return original if parsing fails
    }
};

const convertNodeToHtml = (node: any): string => {
    if (!node || !node.children) {
        return '';
    }
    
    let html = '';
    
    for (const child of node.children) {
        html += convertChildNodeToHtml(child);
    }
    
    return html;
};

const convertChildNodeToHtml = (node: any): string => {
    if (!node) return '';
    
    const { type, children, text, format, tag, value, checked, src, altText, url } = node;
    
    switch (type) {
        case 'paragraph':
            return `<p>${convertNodeToHtml(node)}</p>`;
            
        case 'heading':
            const headingTag = tag || 'h1';
            return `<${headingTag}>${convertNodeToHtml(node)}</${headingTag}>`;
            
        case 'list':
            const listTag = tag === 'ol' ? 'ol' : 'ul';
            return `<${listTag}>${convertNodeToHtml(node)}</${listTag}>`;
            
        case 'listitem':
            return `<li>${convertNodeToHtml(node)}</li>`;
            
        case 'quote':
            return `<blockquote>${convertNodeToHtml(node)}</blockquote>`;
            
        case 'code':
            return `<pre><code>${convertNodeToHtml(node)}</code></pre>`;
            
        case 'text':
            if (!text) return '';
            
            let textContent = text;
            
            // Apply formatting
            if (format & 1) textContent = `<strong>${textContent}</strong>`; // Bold
            if (format & 2) textContent = `<em>${textContent}</em>`; // Italic
            if (format & 4) textContent = `<u>${textContent}</u>`; // Underline
            if (format & 8) textContent = `<a href="${url || '#'}">${textContent}</a>`; // Link
            if (format & 16) textContent = `<code>${textContent}</code>`; // Code
            
            return textContent;
            
        case 'image':
            return `<img src="${src || ''}" alt="${altText || ''}" style="max-width: 100%; height: auto;" />`;
            
        case 'checkbox':
            const checkedAttr = checked ? 'checked' : '';
            return `<input type="checkbox" ${checkedAttr} disabled /> ${convertNodeToHtml(node)}`;
            
        case 'link':
            return `<a href="${url || '#'}" target="_blank" rel="noopener noreferrer">${convertNodeToHtml(node)}</a>`;
            
        case 'table':
            return `<table style="border-collapse: collapse; border: 1px solid #ccc; width: 100%;">${convertNodeToHtml(node)}</table>`;
            
        case 'tablerow':
            return `<tr style="border: 1px solid #ccc;">${convertNodeToHtml(node)}</tr>`;
            
        case 'tablecell':
            const cellTag = node.header ? 'th' : 'td';
            const cellStyle = 'border: 1px solid #ccc; padding: 6px 8px; vertical-align: top;';
            return `<${cellTag} style="${cellStyle}">${convertNodeToHtml(node)}</${cellTag}>`;
            
        default:
            // For unknown node types, try to convert children
            if (children) {
                return convertNodeToHtml(node);
            }
            return '';
    }
}; 